module.exports = __webpack_public_path__ + "img/th_TH.d89e226.jpg";